import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import messages from './messages'

export function validationSuite(
  name: string,
  intl: IntlShape,
  maxEntries?: number
) {
  return create((valuesLength: number) => {
    const { formatMessage: i18n } = intl
    const { validation } = messages

    omitWhen(!maxEntries, () => {
      test(name, i18n(validation.maxEntries, { limit: maxEntries }), () => {
        enforce(valuesLength).lessThan(maxEntries)
      })
    })
  })
}
